const SendForSignatureStateEnum = {
  ADD_FIELDS: 'SEND_FOR_SIGNATURE_TOOLBAR_ADD_FIELDS',
  ADD_MESSAGE: 'SEND_FOR_SIGNATURE_TOOLBAR_ADD_MESSAGE',
  ADD_RECIPIENTS: 'SEND_FOR_SIGNATURE_TOOLBAR_ADD_RECIPIENTS',
  REQUEST_CONFIRM: 'SEND_FOR_SIGNATURE_TOOLBAR_REQUEST_CONFIRM',
  REQUEST_CANCEL: 'SEND_FOR_SIGNATURE_TOOLBAR_REQUEST_CANCEL',
  REQUEST_PENDING: 'SEND_FOR_SIGNATURE_TOOLBAR_REQUEST_PENDING',
  REQUEST_PENDING_CANCEL: 'SEND_FOR_SIGNATURE_TOOLBAR_REQUEST_PENDING_CANCEL',
  REQUEST_SENT: 'SEND_FOR_SIGNATURE_TOOLBAR_REQUEST_SENT',
  UPDATE_FIELDS: 'SEND_FOR_SIGNATURE_TOOLBAR_UPDATE_FIELDS',
  UPDATE_RECIPIENTS: 'SEND_FOR_SIGNATURE_TOOLBAR_UPDATE_RECIPIENTS',
  HIDE_TOOLBAR_NOTIFICATION: 'SEND_FOR_SIGNATURE_TOOLBAR_NOTIFICATIONS_HIDE',
  SET_ERROR: 'SEND_FOR_SIGNATURE_SET_ERROR',
  SET_SUCCESS: 'SEND_FOR_SIGNATURE_SET_SUCCESS',
  SET_WARNING: 'SEND_FOR_SIGNATURE_SET_WARNING',
  SEND_FOR_SIGNATURE_SIGNATURE_TABS_SHOW: 'SEND_FOR_SIGNATURE_SIGNATURE_TABS_SHOW',
  SEND_FOR_SIGNATURE_SHOW_RECIPIENT_WAITING: 'SEND_FOR_SIGNATURE_SHOW_RECIPIENT_WAITING',
  SEND_FOR_SIGNATURE_SHOW_SENDER_SIGNING: 'SEND_FOR_SIGNATURE_SHOW_SENDER_SIGNING',
  SEND_FOR_SIGNATURE_SHOW_SIGNATURE_STATE: 'SEND_FOR_SIGNATURE_SHOW_SIGNATURE_STATE',
  SEND_FOR_SIGNATURE_SENDER_DONE_SIGNING: 'SEND_FOR_SIGNATURE_SENDER_DONE_SIGNING',
};

export const SendForSignatureMessageEnum = {
  LIMIT_ONE_RECIPIENT_MESSAGE: 'You can only send to one recipient at a time.',
  SAME_EMAIL_ERROR_MESSAGE: 'You cannot send a signature request to yourself. Please download the document instead.',
  SAME_EMAIL_TABBED_ERROR_MESSAGE: 'Click "Add Yourself as a Signer" to sign this document along with your recipient.',
  RECIPIENT_SIGNED_FIRST_MESSAGE: 'Thank you for signing! We will email you when the sender has signed this document.',
  SENDER_SIGNED_FIRST_MESSAGE: 'Thank you for signing! We will email you when your recipient has signed this document.',
};

export const SendForSignatureNotificationTypeEnum = {
  NOTIFICATION_ERROR: 'notification-error',
  NOTIFICATION_SUCCESS: 'notification-success',
  NOTIFICATION_WARNING: 'notification-warning',
};

export const StepToMessage = {
  [SendForSignatureStateEnum.REQUEST_CANCEL]: 'Request Cancelled.',
  [SendForSignatureStateEnum.REQUEST_SENT]: 'Request Sent! We will email you when the document has been signed.',
};

export const StepToNotificationType = {
  [SendForSignatureStateEnum.REQUEST_CANCEL]:
    SendForSignatureNotificationTypeEnum.NOTIFICATION_ERROR,
  [SendForSignatureStateEnum.REQUEST_SENT]:
    SendForSignatureNotificationTypeEnum.NOTIFICATION_SUCCESS,
};

export const SendForSignatureNotificationTypeToMessageAction = {
  [SendForSignatureNotificationTypeEnum.NOTIFICATION_ERROR]:
    SendForSignatureStateEnum.SET_ERROR,
  [SendForSignatureNotificationTypeEnum.NOTIFICATION_SUCCESS]:
    SendForSignatureStateEnum.SET_SUCCESS,
  [SendForSignatureNotificationTypeEnum.NOTIFICATION_WARNING]:
    SendForSignatureStateEnum.SET_WARNING,
};

export default SendForSignatureStateEnum;



// WEBPACK FOOTER //
// ./src-react/SendForSignatureToolbar/SendForSignatureToolbarConstants.jsx